import { Box, NavLink, SimpleGrid, Text, Modal } from "@mantine/core";
import { Icon } from "@iconify/react";
import FileInputForm from "./FileInputForm";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function Equipment() {
  const { t } = useTranslation();

  const [opened, setOpened] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); // Currently selected equipment

  const openModal = (item) => {
    setSelectedItem(item);
    setOpened(true);
  };

  const equipmentItems = [
    {
      key: "kitchen",
      label: t("equipment.titles.kitchen"),
      icon: "fa6-solid:kitchen-set",
      hasExtra: {
        label: t("equipment.titles.kitchen_extra"),
        array: t("equipment.kitchen_extra", { returnObjects: true }),
      },
    },
    {
      key: "bathroom",
      label: t("equipment.titles.bathroom"),
      icon: "mdi:bathroom",
    },
    {
      key: "heating",
      label: t("equipment.titles.heating"),
      icon: "iconoir:heating",
    },
    {
      key: "living_room",
      label: t("equipment.titles.living_room"),
      icon: "mdi:living-room",
    },
    {
      key: "bedroom",
      label: t("equipment.titles.bedroom"),
      icon: "mdi:bedroom-outline",
    },
    {
      key: "entertainment",
      label: t("equipment.titles.entertainment"),
      icon: "ic:outline-directions-bike",
      hasExtra: {
        label: t("equipment.titles.bike"),
        array: t("equipment.bike", { returnObjects: true }),
      },
    },
    {
      key: "children",
      label: t("equipment.titles.children"),
      icon: "mdi:children-toy",
    },
    {
      key: "safety",
      label: t("equipment.titles.safety"),
      icon: "foundation:safety-cone",
    },
    {
      key: "outside",
      label: t("equipment.titles.outside"),
      icon: "ph:tree-evergreen-fill",
    },
    {
      key: "internet",
      label: t("equipment.titles.internet"),
      icon: "material-symbols:wifi",
    },
    {
      key: "desk",
      label: t("equipment.titles.desk"),
      icon: "mdi:desk-lamp",
    },
    {
      key: "washing",
      label: t("equipment.titles.washing"),
      icon: "icon-park-outline:washing-machine",
    },
    {
      key: "accessibility",
      label: t("equipment.titles.accessibility"),
      icon: "carbon:accessibility",
    },
    {
      key: "parking",
      label: t("equipment.titles.parking"),
      icon: "ic:twotone-miscellaneous-services",
    },
    {
      key: "entree",
      label: t("equipment.titles.entree"),
      icon: "mdi:hallway",
    },
  ];

  return (
    <div className="stripe">
      <SimpleGrid
        cols={3}
        spacing="lg"
        breakpoints={[
          { maxWidth: "md", cols: 2, spacing: "md" },
          { maxWidth: "sm", cols: 2, spacing: "sm" },
        ]}
      >
        {equipmentItems.map((item) => (
          <Box
            key={item.key}
            style={{ paddingTop: 10 }}
            display="flex"
            justify="center"
          >
            <div
              className="icon-container-new"
              onClick={() => openModal(item)}
              style={{ cursor: "pointer" }}
            >
              <div
                className="icon-circle"
                style={{
                  backgroundColor: "#fff5f5",
                  borderRadius: "50%",
                  width: 80,
                  height: 80,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 auto 10px",
                }}
              >
                <Icon icon={item.icon} fontSize="30px" color="gray.800" />
              </div>
              <Text className="icon-label" fw={600}>
                {item.label.charAt(0).toUpperCase() + item.label.slice(1)}
              </Text>
            </div>
          </Box>
        ))}
      </SimpleGrid>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={selectedItem?.label}
        size="lg"
        centered
      >
        {selectedItem && (
          <>
            <FileInputForm
              title={selectedItem.key}
              array={
                Array.isArray(
                  t(`equipment.${selectedItem.key}`, { returnObjects: true })
                )
                  ? t(`equipment.${selectedItem.key}`, { returnObjects: true })
                  : []
              }
            />
            {selectedItem.hasExtra && (
              <NavLink label={selectedItem.hasExtra.label} childrenOffset={28}>
                <FileInputForm
                  title={selectedItem.hasExtra.label
                    .toLowerCase()
                    .replace(/\s/g, "_")}
                  array={
                    Array.isArray(selectedItem.hasExtra.array)
                      ? selectedItem.hasExtra.array
                      : []
                  }
                />
              </NavLink>
            )}
          </>
        )}
      </Modal>
    </div>
  );
}
